// Hydrate the ticker from @custom.ticker_brands (a comma-separated string
// passed via data-ticker-brands). Partial ships a hardcoded fallback list so
// the ticker renders before JS executes and for users who customise the setting.

export default function ticker() {
    const el = document.querySelector('[data-ticker]');
    if (!el) return;

    const raw = el.dataset.tickerBrands;
    if (!raw) return;

    const brands = raw.split(',').map((b) => b.trim()).filter(Boolean);
    if (brands.length === 0) return;

    const html = brands.map((b) => `<li>${escapeHtml(b)}</li>`).join('');
    el.querySelectorAll('[data-ticker-track]').forEach((track) => {
        track.innerHTML = html;
    });
}

function escapeHtml(str) {
    return str.replace(/[&<>"']/g, (c) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    }[c]));
}
